import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home/Index.vue"),
  },
  {
    path: "/cmsIframe",
    name: "CmsIframe",
    component: () => import("../views/Home/CmsIframe.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login/Index.vue"),
  },
  {
    path: "/sso",
    name: "SSO",
    component: () => import("../views/Login/SSO.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Login/Index.vue"),
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("../views/Logout/Index.vue"),
  },
  {
    path: "/search",
    name: "Search",
    component: () => import("../views/Search/Index.vue"),
  },
  {
    path: "/detail/:id",
    name: "Detail",
    component: () => import("../views/Detail/Index.vue"),
  },
  {
    path: "/order",
    name: "Order",
    component: () => import("../views/Order/Index.vue"),
  },
  {
    path: "/quick",
    name: "Quick",
    component: () => import("../views/Quick/Index.vue"),
  },  
  {
    path: "/order/confirm/:id",
    name: "OrderConfirm",
    component: () => import("../views/Order/Confirm.vue"),
  },
  {
    path: "/order/detail/:order_no",
    name: "OrderDetail",
    component: () => import("../views/Order/Detail.vue"),
  },
  {
    path: "/order/checkout/:id",
    name: "OrderCheckOut",
    component: () => import("../views/Order/CheckOut.vue"),
  },
  {
    path: "/category/:type/:name",
    name: "Category",
    component: () => import("../views/Category/Index.vue"),
  },
  {
    path: "/account",
    name: "Account",
    component: () => import("../views/Enterprise/Account.vue"),
  },
  {
    path: "/account/add",
    name: "AccountAdd",
    component: () => import("../views/Enterprise/AccountAdd.vue"),
  },
  {
    path: "/account/edit",
    name: "AccountEdit",
    component: () => import("../views/Enterprise/AccountEdit.vue"),
  },
  {
    path: "/inquiry",
    name: "Inquiry",
    component: () => import("../views/Inquiry/Index.vue"),
  },
  {
    path: "/address",
    name: "Address",
    component: () => import("../views/Address/Index.vue"),
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/Profile/Index.vue"),
  },
  {
    path: "/info",
    name: "Info",
    component: () => import("../views/Profile/Info.vue"),
  },
  {
    path: "/password",
    name: "Password",
    component: () => import("../views/Profile/Password.vue"),
  },
  {
    path: "/pay_password",
    name: "PayPassword",
    component: () => import("../views/Profile/PayPassword.vue"),
  },
  {
    path: "/cart",
    name: "Cart",
    component: () => import("../views/Cart/Index.vue"),
  },
  {
    path: "/like",
    name: "Like",
    component: () => import("../views/Like/Index.vue"),
  },
  {
    path: "/message",
    name: "Message",
    component: () => import("../views/Message/Index.vue"),
  },
  {
    path: "/enterprice/order",
    name: "EnterpriceOrder",
    component: () => import("../views/Enterprise/Order.vue"),
  },
  {
    path: "/inquiry/order",
    name: "Inquiry/Order",
    component: () => import("../views/Inquiry/Order.vue"),
  },
  {
    path: "/transfer",
    name: "Transfer",
    component: () => import("../views/Layout/Transfer.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "article",
    component: () => import("../views/Article/Index.vue"),
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
export default router;
